import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_kaur-studio/artifacts/33hz2s76_1000036423.jpg" 
              alt="Nanaki Kaur Logo" 
              className="h-20 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm">
              Empowering women through education, training, employment, and self-sustaining entrepreneurship.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-purple-400 transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-purple-400 transition">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-purple-400 transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/register-angel" className="text-gray-400 hover:text-purple-400 transition">
                  Become a Nanaki's Kaur
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Brands */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Brands</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Nuskay Skincare</li>
              <li>Nanaki Art x Apparel</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-2 text-gray-400">
                <Phone className="w-4 h-4" />
                <span>+91 99-30-11-18-23</span>
              </div>
              <a
                href="mailto:jasjeevbhasin5757@gmail.com"
                className="flex items-center space-x-2 text-gray-400 hover:text-purple-400 transition"
              >
                <Mail className="w-4 h-4" />
                <span>jasjeevbhasin5757@gmail.com</span>
              </a>
              <a
                href="https://www.instagram.com/jasjeev23"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-400 hover:text-purple-400 transition"
              >
                <Instagram className="w-4 h-4" />
                <span>@jasjeev23</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Nanaki Kaur. All rights reserved.</p>
          <p className="mt-2 text-xs">Conquering all fields, a pen is all she Wields.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;